import { UEditorComponent } from './ueditor.component';

export const COMPONENTS = [UEditorComponent];
